import { partHtml } from '@/pages/[categorias]/[...news]';

type ContentRearrangerProps = {
  content: partHtml[];
  useVideoAd?: boolean;
  videoAdOptions?: {
    enableMobile?: boolean;
    enableDesktop?: boolean;
    positionMobile?: number;
    positionDesktop?: number;
  };
  adsOptions?: {
    enableMobile?: boolean;
    enableDesktop?: boolean;
    positionMobile?: number;
    positionDesktop?: number;
  };
  shouldUseIdCountPosition?: boolean;
};

export function contentRearranger({
  content,
  useVideoAd = true,
  adsOptions = { enableMobile: true, enableDesktop: true, positionMobile: 4, positionDesktop: 4 },
  videoAdOptions = { enableMobile: true, enableDesktop: true, positionMobile: 1, positionDesktop: 2 },
  shouldUseIdCountPosition = true,
}: ContentRearrangerProps) {
  const length = content?.length;
  const maxIdCountPosition = 10;

  if (length < adsOptions.positionMobile && length < adsOptions.positionDesktop) return content;

  const isValidDesktop = (i = +1) => i % adsOptions.positionDesktop === 0 && i >= adsOptions.positionDesktop && i < length && adsOptions.enableDesktop;
  const isValidMobile = (i = +1) => i % adsOptions.positionMobile === 0 && i >= adsOptions.positionMobile && i < length && adsOptions.enableMobile;

  const shouldRenderVideoAdMobile = (i = +1) => useVideoAd && videoAdOptions.enableMobile && i === adsOptions.positionMobile * videoAdOptions.positionMobile;

  const shouldRenderVideoAdDesktop = (i = +1) =>
    useVideoAd && videoAdOptions.enableDesktop && i === adsOptions.positionDesktop * videoAdOptions.positionDesktop;

  const contentRearranged = [];
  let adMobileCount = 1;
  let adDesktopCount = 1;

  const adVideoM = { tipo: 'adVideoGtmMobile' };
  const adVideoD = { tipo: 'adVideoGtmDesktop' };

  content.forEach((block, i) => {
    const adMobile = { tipo: 'adMobile', idCountPosition: shouldUseIdCountPosition && adMobileCount <= maxIdCountPosition ? adMobileCount.toString() : '' };
    const adDesktop = { tipo: 'adDesktop', idCountPosition: shouldUseIdCountPosition && adDesktopCount <= maxIdCountPosition ? adDesktopCount.toString() : '' };

    if (content.length >= 4 && i === 4) {
      contentRearranged.push({ tipo: 'cardCTA' });
    }

    if (i === 1) {
      contentRearranged.push(adMobile);
      adMobileCount += 1;
      contentRearranged.push(adDesktop);
      adDesktopCount += 1;
    }

    if (isValidMobile(i) && shouldRenderVideoAdMobile(i)) contentRearranged.push(adVideoM);
    if (isValidMobile(i) && !shouldRenderVideoAdMobile(i)) {
      if (adMobileCount <= maxIdCountPosition) contentRearranged.push(adMobile);
      if (adMobileCount <= maxIdCountPosition) adMobileCount += 1;
    }

    if (isValidDesktop(i) && shouldRenderVideoAdDesktop(i)) contentRearranged.push(adVideoD);
    if (isValidDesktop(i) && !shouldRenderVideoAdDesktop(i)) {
      if (adDesktopCount <= maxIdCountPosition) contentRearranged.push(adDesktop);
      if (adDesktopCount <= maxIdCountPosition) adDesktopCount += 1;
    }

    contentRearranged.push(block);

    if (content.length > 9 && i === 8) {
      contentRearranged.push({ tipo: 'readMore' });
    }
  });

  return contentRearranged;
}

interface AdsContains {
  ads: boolean;
  mobile: boolean;
}

const adsContainsMobile: AdsContains = {
  ads: true,
  mobile: true,
};

const adsContainsDesktop: AdsContains = {
  ads: true,
  mobile: false,
};

interface listingRearrangerProps<Type> {
  content: Type[];
  primary: boolean;
  hasNoAds?: boolean;
  sizeMobile?: number;
  sizeDesktop?: number;
}

export function listingRearranger<Type>({ content, primary, hasNoAds = false, sizeMobile = 3, sizeDesktop = 6 }: listingRearrangerProps<Type>) {
  const length = content?.length;
  const result = [];

  if (!primary) {
    result.push(adsContainsDesktop);
  }

  let chunkified = [];

  content.forEach((element: Type, index: number) => {
    chunkified.push(element);

    if ((index + 1) % sizeMobile === 0 && index + 1 >= sizeMobile && !hasNoAds) chunkified.push(adsContainsMobile);
    if ((index + 1) % sizeDesktop === 0 && index + 1 >= sizeDesktop) {
      result.push({ chunck: chunkified });
      if (index + 1 < length && !hasNoAds) result.push(adsContainsDesktop);
      chunkified = [];
    }
    if (chunkified.length > 0 && length === index + 1) {
      result.push({ chunck: chunkified });
    }
  });

  return result as ({ chunck: (Type | AdsContains)[] } | AdsContains)[];
}

export default { contentRearranger, listingRearranger };
